module.exports = window.XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./~/httpplease/lib/xhr-browser.js
// module id = 760
// module chunks = 4